angular.module('leanlaw').controller('ClientBillingActivityCtrl', ['$state', '$stateParams', '$scope', function ($state, $stateParams, $scope) {
  if (!$scope.me.permissions.matters.overview) {
    $state.go('clients.client.view.info', {
      id: $stateParams.id
    });
  }
  $scope.vm = {
    module: $scope.module
  };
}]);